import React, { memo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';

const Costs = memo(function Costs({ data }) {
    
    if (data) {
        return (
            <DataGrid
                dataSource={data}
                columnAutoWidth={true}
                showBorders={true} 
            >
                <Column caption="Total Task Cost" alignment="center">  
                    <Column dataField="programManagementCost" />
                    <Column dataField="operationsCost" />
                    <Column dataField="materialsCost" />
                    <Column dataField="totalCost" caption="Total"/>
                </Column>
            </DataGrid>
        )
    }
});

export default Costs;